import * as React from 'react';
import classnames from 'classnames';
import { Link } from '@grandvisionhq/common';
import { StepForm, ConfiguratorStepTitleAndDescription } from '@grandvisionhq/configurator';
import { Icon } from '@grandvisionhq/icons';
import { ConfiguratorRadioTile } from '../../../components/ConfiguratorRadioTile/ConfiguratorRadioTile.js';
import { RxStepWrapper } from '../RxStepWrapper/RxStepWrapper.js';
import DesktopStepLayout from '../DesktopStepLayout/DesktopStepLayout.js';

const ProductSelectionStep = ({ className , itemsList , selectedItemSku , readMoreLink , step , onChange , onSubmit ,  })=>{
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: classnames('product-selection-step', className)
    }, /*#__PURE__*/ React.createElement(DesktopStepLayout, null, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit,
        className: "product-selection-step__wrapper"
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: "left"
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-selection-step__products', className),
        "data-t": "product-selection-step-products"
    }, /*#__PURE__*/ React.createElement("fieldset", {
        className: "product-selection-step__list"
    }, itemsList.map((item)=>{
        var ref, ref1, ref2;
         return React.createElement(ConfiguratorRadioTile, {
            className: "product-selection-step__list-item",
            isSelected: selectedItemSku === item.sku,
            onChange: onChange,
            value: item.sku,
            key: item.sku,
            title: item.title,
            image: (ref = item.image_v2) === null || ref === void 0 ? void 0 : ref.url,
            description: item.description,
            price: item.price,
            discountText: item.discountText,
            uspList: item.usps,
            tag: (ref1 = item.tags) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.value,
            step: step
        });
    })), readMoreLink && /*#__PURE__*/ React.createElement(Link, {
        className: "product-selection-step__read-more",
        url: readMoreLink.url,
        openInNewWindow: readMoreLink.openInNewWindow
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "product-selection-step__read-more-icon",
        name: "info"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "product-selection-step__read-more-text"
    }, readMoreLink.label))))));
};

export { ProductSelectionStep };
//# sourceMappingURL=ProductSelectionStep.js.map
